import { Component } from 'react';

export default class PostsIcon extends Component {
  render() {
    return (
      <svg width="13px" height="13px" viewBox="0 0 13 13">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-686.000000, -299.000000)" stroke="#262626">
            <g transform="translate(686.000000, 299.000000)">
              <rect
                id="Rectangle"
                x="0.5"
                y="0.5"
                width="12"
                height="12"
              ></rect>
              <rect
                id="Rectangle-Copy"
                x="0.5"
                y="4.5"
                width="12"
                height="4"
              ></rect>
              <rect
                id="Rectangle-Copy"
                transform="translate(6.500000, 6.500000) rotate(-270.000000) translate(-6.500000, -6.500000) "
                x="0.5"
                y="4.5"
                width="12"
                height="4"
              ></rect>
            </g>
          </g>
        </g>
      </svg>
    );
  }
}
